import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, serviceConstants, zipapiURL, formOptions } from '../constants/service.constants';
import { City, ZipResponse, ZipData, Menu } from 'src/app/models/common';
import { Observable, timer } from 'rxjs';
import { catchError, map, retry, switchMap, tap } from 'rxjs/operators';
import { IST_APP, EAP_APP, GM_APP } from 'src/app/models/common';
import { ModuleMenu } from 'src/app/models/common';
import { Organization } from 'src/app/models/um/organization';
import { SuccessBanertemplateComponent } from '../common/success-banertemplate/success-banertemplate.component';
import { ErrorbannerComponent } from '../common/errorbanner/errorbanner.component';
import { UserService } from './user.service';
import { MessageBoxComponent } from '../common/message-box/message-box.component';
import { DeleteBoxComponent } from '../common/delete-box/delete-box.component';
import { ConfirmationBoxComponent } from '../common/confirmation-box/confirmation-box.component';
import { IstSummaryService } from './ist/ist-summary.service';
import { HeadService } from './common/headservice';
import { Router } from '@angular/router';
import { IstDataShareService } from './ist/ist-datashare.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrantsDatashareService } from './grants/grants-datashare.service';
@Injectable({
  providedIn: 'root'
})

export class CommonService {

  zipresponse: ZipResponse;
  istapp: IST_APP;
  eapapp: EAP_APP;
  grantsapp: GM_APP;
  appId: string;
  ScreenID: string;
  leftmenus: Menu[] = [];
  topmenus: Menu[] = [];
  objcity: Observable<City>;
  menu: ModuleMenu;
  orgs: Organization[] = [];
  menudata: ModuleMenu;
  constructor(private http: HttpClient,
    private modalService: NgbModal,
    private userService: UserService,
    private summaryService: IstSummaryService,
    private header: HeadService,
    private router: Router, private dataShare: IstDataShareService, private GrantsShare: GrantsDatashareService) {

  }

  isAutocodeConfigured(featureid: string, orgid: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/isautoconfigured/' + featureid + '/' + orgid, httpOptions)
  }
  activeFeature(table: string, id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/active/' + table + '/' + id, httpOptions)
  }

  inactiveFeature(table: string, id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/inactive/' + table + '/' + id, httpOptions)
  }

  checkMandatoryFormFileds(appid: string, action: string, module: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/common/checkmandatory/' + appid + '/' + action + '/' + module, formOptions)
  }

  updateMandatoryFormFileds(appid: string, action: string, module: string, featurecode: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/common/UpadteManadotory/' + appid + '/' + action + '/' + module + '/' + featurecode, httpOptions)
  }

  getMenu(id: string, code: string, state: string, operation: string): Observable<Menu[]> {
    return this.http.get<Menu[]>(serviceConstants.apiURL + 'api/common/getmodulefeatures/' + id + '/' + code + '/' + state + '/' + operation, httpOptions)
  }

  getModulesList(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/common/getmodules", httpOptions);
  }

  getCity(zip: string): Observable<ZipResponse> {
    return this.http.get<ZipResponse>(serviceConstants.apiURL + 'api/common/getzipinfo/' + zip, httpOptions);

    ////let url = zipapiURL.replace("@zipcode@", zip);
    //let url = serviceConstants.apiURL + 'api/common/getzipinfo/' + zip;
    //return this.http.get<ZipResponse>(url).pipe(
    //  tap( // Check the Valid request
    //    data => {

    //    },
    //    error => {

    //    }
    //  )
    //);
  }


  getRegCity(zip: string): Observable<ZipResponse> {
    return this.http.get<ZipResponse>(serviceConstants.apiURL + 'api/appuser/getzipinfo/' + zip, httpOptions);
  }

  getNotificationCount(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Notifications/NotificationCount', httpOptions);
  }
  GetChangeLogInfo(appId: string, module_id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getchangelogInfo/' + appId + "/" + module_id, httpOptions);
  }
  setModluleMenu(menu: ModuleMenu) {
    this.menu = menu;
    localStorage.setItem('menu', JSON.stringify(menu));
  }

  getModuleMenu() {
    if (this.menu === null || this.menu === undefined) {
      this.menu = JSON.parse(localStorage.getItem("menu"));
    }
    return this.menu;
  }

  removeModuleMenu() {
    localStorage.setItem('menu', null);
    this.menu=null;
  }
  setISTApp(app) {
    this.istapp = app;
    localStorage.setItem('istapp', JSON.stringify(app));
  }

  removeISTApp() {
    this.istapp = null;
    localStorage.setItem('istapp', null);
  }

  setEAPApp(app) {
    this.eapapp = app;
    localStorage.setItem('eapapp', JSON.stringify(app));
  }

  removeEAPApp() {
    this.eapapp = null;
    localStorage.setItem('eapapp', null);
  }

  setGrantsApp(app) {
    this.grantsapp = app;
    localStorage.setItem('grantsapp', JSON.stringify(app));
  }

  removeGrantsApp() {
    this.grantsapp = null;
    localStorage.setItem('grantsapp', null);
  }

  getISTApp() {
    if (this.istapp === null || this.istapp === undefined) {
      this.istapp = JSON.parse(localStorage.getItem("istapp"));
    }
    return this.istapp;
  }

  getIstStatus(): boolean {
    let IsSubmitRequired = false;
    this.istapp = JSON.parse(localStorage.getItem("istapp"));
    IsSubmitRequired = this.istapp.STATUS == 1 ? false : true;
    return IsSubmitRequired;
  }

  getEAPApp() {
    if (this.eapapp === null || this.eapapp === undefined) {
      this.eapapp = JSON.parse(localStorage.getItem("eapapp"));
    }
    return this.eapapp;
  }

  getGrantsApp() {
    if (this.grantsapp === null || this.grantsapp === undefined) {
      this.grantsapp = JSON.parse(localStorage.getItem("grantsapp"));
    }
    return this.grantsapp;
  }
  getGrantsStatus(): number {
    this.grantsapp = JSON.parse(localStorage.getItem("grantsapp"));
    return this.grantsapp.STATUS;
  }
  setLeftMenu(menus: Menu[]) {
    this.leftmenus = menus;
    localStorage.setItem('leftmenus', JSON.stringify(menus));
  }
  removeLeftMenu() {
    this.leftmenus = [];
    localStorage.setItem('leftmenus', null);
  }
  getLeftMenu() {
    if (this.leftmenus === null || this.leftmenus === undefined) {
      this.leftmenus = JSON.parse(localStorage.getItem("leftmenus"));
    }
    return this.leftmenus;
  }

  getModuleName() {
    let name = "";
    let menus = JSON.parse(localStorage.getItem("menu"));
    if (menus != undefined && menus != null) {
      name = menus.module;
    }
    return name;

  }


  setTopMenu(menus: Menu[]) {
    this.topmenus = menus;
    localStorage.setItem('topmenus', JSON.stringify(menus));
  }

  getTopMenu() {
    if (this.topmenus === null || this.topmenus === undefined) {
      this.topmenus = JSON.parse(localStorage.getItem("topmenus"));
    }
    return this.topmenus;
  }

  getPagePermission(pagecode: string) {
    //debugger;
    let permission = "";
    if (this.leftmenus === null || this.leftmenus === undefined) {
      this.leftmenus = JSON.parse(localStorage.getItem("leftmenus"));
    }

    if (this.leftmenus !== null && this.leftmenus !== undefined) {
      const len = this.leftmenus.length;
      for (let iCount = 0; iCount < len; iCount++) {
        if (this.leftmenus[iCount].Code == pagecode) {
          permission = this.leftmenus[iCount].Operation;
          break;
        }
      }
    }
    if (permission === "") {
      if (this.topmenus === null || this.topmenus === undefined) {
        this.topmenus = JSON.parse(localStorage.getItem("topmenus"));
      }

      if (this.topmenus !== null && this.topmenus !== undefined) {
        const len = this.topmenus.length;
        for (let iCount = 0; iCount < len; iCount++) {
          if (this.topmenus[iCount].Code == pagecode) {
            permission = this.topmenus[iCount].Operation;
            break;
          }
        }
      }
    }
    return permission;
  }

  getScreenPermission(pagecode: string, Operation: string) {
    let IsHadPermission = false;
    let UserData = this.userService.getUserDetais()
    if (UserData != null && UserData != undefined) {
      UserData.FEATURES.forEach(element => {
        var isScreenExits = element.Features.filter(function (item) {
          return item.Code == pagecode;
        })[0];
        if (isScreenExits != undefined && isScreenExits != null) {
          if (isScreenExits.OperationMapped.indexOf(Operation) > -1) {
            IsHadPermission = true;
          }
        }
      });
    }
    return IsHadPermission;
  }

  getModuleId(module: string): string {
    let modid = "";
    switch (module) {
      case "ist":
        modid = "2";
        break;
      case "eap":
        modid = "4";
        break;
      case "grantscme":
      case "grants":
        modid = "4";
        break;
      case "grantssponsership":
        modid = "3";
        break;
      case "grantscharitable":
        modid = "7";
        break;
    }

    return modid;
  }

  setOrganizations(orgs) {
    this.orgs = orgs;
    localStorage.setItem("organizations", JSON.stringify(orgs));
  }

  getOrganization(code: string): string {
    let orgname = "";
    let orgId = "";

    if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(localStorage.getItem("organizations"));
    }
    if (this.orgs === null || this.orgs === undefined)
      return "";
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          orgname = this.orgs[i].NAME
          break;
        }
      }
      return orgname;
    }
  }

  getOrganizationObject(code: string): Organization {
    let org=null;

    //if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(localStorage.getItem("organizations"));
   // }
    if (this.orgs === null || this.orgs === undefined)
      return null;
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          org = this.orgs[i]
          break;
        }
      }
      return org;
    }
  }

  getOrganizationStatus(code: string): number {
    let num = 0;

    if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(localStorage.getItem("organizations"));
    }
    if (this.orgs === null || this.orgs === undefined)
      return 0;
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          num = this.orgs[i].RECORD_STATE
          break;
        }
      }
      return num;
    }
  }


  getOrganizationId(code: string): string {
    let orgId = "";

    if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(localStorage.getItem("organizations"));
    }
    if (this.orgs === null || this.orgs === undefined)
      return "";
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          orgId = this.orgs[i].ID
          break;
        }
      }
      return orgId;
    }
  }


  getStatus(statusnum: number): string {
    let status = "";
    switch (statusnum) {
      case 0:
        status = "Draft";
        break;
      case 1:
        status = "Draft";
        break;
      case 2:
        status = "Submitted";
        break;
      case 3:
        status = "Review Ongoing";
        break;
      case 4:
        status = "Accepted";
        break;
      case 5:
        status = "Closed";
        break;
      case 6:
        status = "Reject";
        break;
      case 7:
        status = "Onhold";
        break;
      case 8:
        status = "Withdrawn";
        break;
      case 9:
        status = "Discard";
        break;
      case 10:
        status = "Assign";
        break;
    }
    return status;
  }

  getUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  ValidationBanner(Message: any) {
    const Modalref = this.modalService.open(MessageBoxComponent,
      { backdrop: false, }
    );
    Modalref.componentInstance.Content = { heading: 'Validation Message(s)', content: { heading: '', description: Message } };
  }
  CanDeactivateBanner() {
    const modalRef = this.modalService.open(ConfirmationBoxComponent, {backdrop: false})
    modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'There are some unsaved details. Do you want to continue?', ProceedButtonName: "Ok", TerminateButtonName: "Cancel" };
    return modalRef.result;
  }
  SuccessBanner(Message: string) {
    const Modalref = this.modalService.open(SuccessBanertemplateComponent,
      {
        windowClass: 'sccsessMessage'
      });
    Modalref.componentInstance.Content = {
      message: Message
    };
  }
  ErrorBanner(Message: string) {
    const Modalref = this.modalService.open(ErrorbannerComponent,
      {
        windowClass: 'lg ErrorMessage',
        backdrop: false,
      });
    Modalref.componentInstance.Content = {
      message: Message
    };
  }

getdisplayedDate(date:string):Date
{
  if(date==null || date==undefined || date=="")
  {
    return null;
  }
  else{
    return new Date(date.replace('Z',''));
  }
}

  previewFile(fileid: string, filename: string, type: string) {
    let encodedFileName = btoa(filename);
    let expandEmailURL = serviceConstants.baseUrl + "/filepreview/" + fileid + "/" + type + "/" + encodedFileName
    window.open(`${expandEmailURL}`, 'Reference Document', 'width=800, height=500');
  }
  validateEmail(email: string): boolean {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  refreshApplicationPage(applicationID: any, Moduleid: any, subModuleID: any) {
    switch (Moduleid) {
      case "ist":
        this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationID).subscribe(data => {
          this.istapp = data;
          this.appId = data.ID;
          this.setISTApp(this.istapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "IST";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.istapp.STATUS);
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/ist/my-applications/application-ext/:' + data['ID'] + '/general_information_request'], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications" } })
        });
        break;
      case "eap":
        this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          this.istapp = data;
          this.appId = data.ID;
          this.setISTApp(this.istapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "EAP";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.istapp.STATUS);
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/eap/my-applications/application-ext/:' + data['ID'] + '/program_info'], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications" } })
        });
        break;
      case "grants":
        let RecordID = "";
        this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          let modulecode = "";
          this.grantsapp = data;
          this.appId =this.grantsapp.ID;
          this.setGrantsApp(this.grantsapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = modulecode;
          this.menudata.operation = "Edit";
          this.menudata.appId = this.grantsapp.ID;
          if (this.grantsapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.grantsapp.STATUS);
       
          this.GrantsShare.setGrantApplicationID(applicationID);

          if (subModuleID.toLocaleString() === "GRANTSCME") {
            modulecode = "GRANTSCME";
            this.GrantsShare.CMEID.subscribe((x) => {
              RecordID = x;
              this.menudata.module = modulecode;
              this.removeLeftMenu();
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
          else if (subModuleID.toLocaleString() === "GRANTSSPONSORSHIP") {
            modulecode = "GRANTSSPONSORSHIP";
            this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
          else if (subModuleID.toLocaleString() === "GRANTSCHARITABLE") {
            modulecode = "GRANTSCHARITABLE";
            this.GrantsShare.CharityID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }


        });

        break;
    }

  }

  getScreenStaticFields(screenCode: string) {
    return this.http.get(serviceConstants.apiURL + `api/screen/StaticControlsData/${screenCode}`, httpOptions);
  }

}
